/**
 * @generated SignedSource<<b00ec137724c8544baeaf2be33b2baf6>>
 * @relayHash 5db81b9beb1feba44efd31bc80e5554c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d533bd9c91bff54ee1b66a66945d76791d0fc9db616793d4b835af3c4996e528

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionDetailsQuery } from './uiVersionDetailsQuery.graphql';

const node: PreloadableConcreteRequest<uiVersionDetailsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d533bd9c91bff54ee1b66a66945d76791d0fc9db616793d4b835af3c4996e528",
    "metadata": {},
    "name": "uiVersionDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
